import React from 'react';
import './content-navigation.css';

export const ContentNavigation = React.forwardRef(({ isFixed, landingSections, toCamelCase, pageLanguage }, ref) => {
  return (
    <div ref={ref} className={`flex justify-center content-navigation ${isFixed ? 'fixed top-0 left-0 right-0 w-full' : 'relative'}`}>
      {landingSections.map((item, index) => (
        <a key={index} href={`#${toCamelCase(item.title)}`}>{item.title}</a>
      ))}
      <a href='/industry-news/'>{pageLanguage !== 'Spanish' ?  'Industry News' : 'Noticias de la industria'}</a>
    </div>
  );
});